import { type CardContentsComponent } from 'components/CardLayoutEditor/models/types';
import React from 'react';

const TagsContents: React.FC<CardContentsComponent<'tags'>> = ({ tags }) => {
  return (
    <aha-tags style={{ fontSize: 11 }}>
      {tags.map(tag => (
        <aha-tag key={tag.name} color={tag.color}>
          <span style={{ whiteSpace: 'nowrap' }}>{tag.name}</span>
        </aha-tag>
      ))}
    </aha-tags>
  );
};

export default TagsContents;
